import { createReducer } from '@reduxjs/toolkit'
import { IWebinar } from 'shared/types'
import { receiveWebinars } from 'model/actions'

const initialState = null as Record<string, IWebinar> | null

const reducer = createReducer(initialState, builder => {
  builder.addCase(receiveWebinars, (state, action) => action.payload)
})

export default reducer
